import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '../mock';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('All');

  const categories = ['All', 'Railings', 'Office Partitions', 'Doors', 'Shower Partitions', 'Commercial Buildings'];

  const filteredImages = filter === 'All'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  return (
    <div data-testid="gallery-page" className="bg-white pt-24 sm:pt-28 pb-16 sm:pb-24">
      {/* Page Header */}
      <section className="py-10 sm:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="font-rajdhani text-brand font-semibold text-xs sm:text-sm tracking-[0.25em] uppercase mb-2 sm:mb-3">
            Portfolio
          </p>
          <h1 className="font-rajdhani text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800">
            Gallery
          </h1>
          <p className="font-roboto text-slate-500 mt-3 sm:mt-4 text-sm sm:text-base max-w-xl mx-auto">
            Explore our portfolio of architectural glass installations
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 sm:py-8 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                data-testid={`gallery-filter-${category.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-3 sm:px-5 py-2 sm:py-2.5 font-rajdhani font-semibold text-xs sm:text-sm transition-all ${
                  filter === category
                    ? 'bg-brand text-white'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
            {filteredImages.map((item) => (
              <div
                key={item.id}
                data-testid={`gallery-item-${item.id}`}
                className="group relative aspect-square overflow-hidden cursor-pointer"
                onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/50 transition-all duration-300"></div>
                <div className="absolute inset-0 p-3 sm:p-5 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="font-rajdhani text-brand-100 text-[10px] sm:text-xs font-semibold tracking-wider uppercase mb-0.5 sm:mb-1">
                    {item.category}
                  </div>
                  <h3 className="font-rajdhani text-white font-bold text-xs sm:text-sm">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-50 bg-slate-900/95 flex items-center justify-center p-3 sm:p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 sm:top-6 sm:right-6 p-2 bg-white/10 hover:bg-white/20 text-white transition-colors"
            data-testid="lightbox-close"
            onClick={() => setSelectedImage(null)}
          >
            <X size={24} />
          </button>

          <div className="max-w-5xl max-h-[85vh] relative" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full h-full object-contain"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 bg-gradient-to-t from-slate-900 to-transparent">
              <div className="font-rajdhani text-brand-100 text-xs font-semibold tracking-wider uppercase mb-1">
                {selectedImage.category}
              </div>
              <h3 className="font-rajdhani text-white text-lg sm:text-xl font-bold">
                {selectedImage.title}
              </h3>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
